import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import CustomButton from '../buttons/CustomButton';
import { useSubscription } from '../../contexts/SubscriptionContext';
import { closureDeadlineText, closureExpiredText, closureOriginText, isClosureOpen } from './companyClosure';

// Mesmo formato dos avisos do topo da página de planos (borda à esquerda), no tom vermelho suave.
const BLOCK_SX = {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    background: '#fff1f2',
    border: '1px solid #fecdd3',
    borderLeft: '3px solid #e11d48',
    borderRadius: '8px',
    padding: '14px 16px',
};

/**
 * Bloco "Conta em encerramento" / "Carência encerrada" no topo do paywall
 * (/subscription/plans). Aparece só com ciclo aberto E conta bloqueada; com
 * acesso, quem avisa é o CompanyClosureBanner.
 * Especificação: docs/features/lgpd-eliminacao/README.md (checkpoint 4)
 */
function CompanyClosurePaywallBlock() {
    const navigate = useNavigate();
    const { closure, hasActiveSubscription } = useSubscription();

    if (!isClosureOpen(closure) || hasActiveSubscription()) return null;

    const expired = closure.state === 'expired';

    return (
        <Box sx={BLOCK_SX}>
            <Typography sx={{ fontSize: '0.875rem', fontWeight: 600, lineHeight: 1.4, color: '#9f1239' }}>
                {expired ? 'Carência encerrada' : 'Conta em encerramento'}
            </Typography>
            <Typography sx={{ fontSize: '0.8125rem', lineHeight: 1.55, color: '#881337' }}>
                {expired
                    ? closureExpiredText(closure)
                    : `${closureOriginText(closure)} ${closureDeadlineText(closure)}`}
            </Typography>
            <Typography sx={{ fontSize: '0.8125rem', lineHeight: 1.55, color: '#881337', fontWeight: 600 }}>
                Para manter a conta, assine um plano abaixo.
            </Typography>
            <Box>
                <CustomButton
                    label="Exportar dados"
                    style="primary"
                    variant="outlined"
                    size="small"
                    icon={<FileDownloadOutlinedIcon fontSize="small" />}
                    onClick={() => navigate('/system/backup')}
                />
            </Box>
        </Box>
    );
}

export default CompanyClosurePaywallBlock;
